module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "component-create-entity-button"
  }, [_c('ModalReveal', {
    ref: "editModal"
  }, [_c('template', {
    slot: "trigger"
  }, [(_vm.item == null) ? _c('a', {
    staticClass: "fa-stack fa-lg"
  }, [_c('i', {
    staticClass: "fa fa-circle fa-stack-2x"
  }), _c('i', {
    staticClass: "fa fa-plus fa-stack-1x fa-inverse"
  })]) : _c('button', {
    staticClass: "button"
  }, [_vm._v("Edit")])]), _c('h2', [_vm._v("Document requirement")]), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "columns"
  }, [_c('label', [_vm._v("Select entity " + _vm._s(_vm.body.entity_type)), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.body.entity_type),
      expression: "body.entity_type"
    }],
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.body, "entity_type", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, _vm._l((_vm.options), function(value) {
    return (_vm.options.length) ? _c('option', {
      domProps: {
        "value": value
      }
    }, [_vm._v(_vm._s(value))]) : _vm._e()
  }), 0)]), (_vm.body.entity_type === 'VehicleCategory') ? _c('selectize-category', {
    attrs: {
      "selected-value": _vm.item.entity.id
    },
    on: {
      "optionSelected": _vm.entitySelected
    }
  }) : _vm._e(), (_vm.body.entity_type === 'Plan') ? _c('selectize-plan', {
    attrs: {
      "selected-value": _vm.item.entity.id
    },
    on: {
      "optionSelected": _vm.entitySelected
    }
  }) : _vm._e(), (_vm.body.entity_type === 'ClientType') ? _c('selectize-client-type', {
    attrs: {
      "selected-value": _vm.item.entity.id
    },
    on: {
      "optionSelected": _vm.entitySelected
    }
  }) : _vm._e()], 1)]), _c('div', {
    staticClass: "row column"
  }, [_c('DocumentRequirementForm', {
    model: {
      value: (_vm.body),
      callback: function($$v) {
        _vm.body = $$v
      },
      expression: "body"
    }
  })], 1), _c('div', {
    staticClass: "row columns text-center"
  }, [_c('ActionButton', {
    attrs: {
      "action": _vm.save
    }
  }, [_vm._v("Update")])], 1)], 2)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-4141d459!./~/vue-loader/lib/template-loader.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/structure/ui/actions/EditDocumentRequirementButtonModal.vue
// module id = 2432
// module chunks = 1